document.addEventListener('DOMContentLoaded', function() {
  if (!window.mz) {
    return
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  function clearSiteMainDimmer() {
    if (mz.site_main_dimmer && typeof mz.site_main_dimmer.clearAll === 'function') {
      mz.site_main_dimmer.clearAll()
      return
    }
    var dimmer = document.querySelector('[data-site-main-dimmer]')
    if (!dimmer) {
      return
    }
    dimmer.setAttribute('data-animation-state', 'closed')
    dimmer.removeAttribute('data-animation')
  }
  function bindSearchDimmerCleanup() {
    document.querySelectorAll('input[name="q"]').forEach(function (input) {
      if (input.dataset.mzDimmerBound) {
        return
      }
      input.dataset.mzDimmerBound = 'true'
      input.addEventListener('blur', clearSiteMainDimmer)
    })
    document.querySelectorAll('form[action*="search"]').forEach(function (form) {
      if (form.dataset.mzDimmerBound) {
        return
      }
      form.dataset.mzDimmerBound = 'true'
      form.addEventListener('submit', clearSiteMainDimmer)
    })
  }
  function afterUpdate() {
    clearSiteMainDimmer()
    bindSearchDimmerCleanup()
    document.querySelectorAll('.mz-skeleton-wrapper').forEach(function (el) {
      el.classList.add('hidden')
    })
    function runInit() {
      if (mz._initProductItems) {
        mz._initProductItems()
      }
      var rimg = mz.rimg_shopify_dist_index_es
      if (rimg && typeof rimg.init === 'function') {
        rimg.init('[data-rimg="lazy"]', { round: 1 })
      }
    }
    if (mz.app && typeof mz.app.$nextTick === 'function') {
      mz.app.$nextTick(runInit)
    } else {
      requestAnimationFrame(function () {
        requestAnimationFrame(runInit)
      })
    }
  }
  clearSiteMainDimmer()
  bindSearchDimmerCleanup()
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
  }
})
